import React from 'react';
import { useRouter } from 'next/router';
import { gql, useQuery } from '@apollo/client';
import { OPPORTUNITY_MEMBER_ROLE } from '@app/apollo/queries';
import ApplicationDetails from '@organisms/Applications/ApplicationDetails';
import ApplicantSidebar from '@organisms/Applications/ApplicationSidebar';
import ViewOpportunityDashboardTemplate from '@app/components/templates/ViewOpportunityDashboard';

export const APPLICATION_DETAILS = gql`
  query viewSubmissionApplication($id: ID!) {
    viewSubmissionApplication(id: $id) {
      ...ApplicantSidebar
      ...ApplicationDetails
    }
  }
  ${ApplicantSidebar.fragments.application}
  ${ApplicationDetails.fragments.application}
`;

const ApplicationPage = () => {
  const router = useRouter();
  const { id: applicationId } = router.query;

  const {
    loading: applicationLoading,
    data: { viewSubmissionApplication } = {}
  } = useQuery(APPLICATION_DETAILS, {
    variables: {
      id: applicationId,
    },
    skip: !applicationId
  });

  const {
    data: { opportunityMemberRole } = {},
    loading: opportunityMemberRoleLoading
  } = useQuery(OPPORTUNITY_MEMBER_ROLE, {
    variables: {
      id: viewSubmissionApplication?.opportunity?.id
    },
    skip: !viewSubmissionApplication?.opportunity?.id
  });

  return (
    !opportunityMemberRoleLoading && !applicationLoading &&
    <ViewOpportunityDashboardTemplate viewApplication opportunity={viewSubmissionApplication?.opportunity} opportunityMemberRole={opportunityMemberRole}>
      <ApplicationDetails userView application={viewSubmissionApplication} />
    </ViewOpportunityDashboardTemplate>
  );
};

ApplicationPage.propTypes = {};

export async function getServerSideProps() {
  return {
    props: {
      namespacesRequired: ['common', 'dashboard', 'wizard', 'payment', 'applications'],
    }
  }
}



// ApplicationPage.guard = async ({req, apolloClient, res}, user) => {
//   const {id} = req.query;
//   if(res.statusCode !== 200) {
//     res.end();
//     return;
//   }
//   const can = await canManageApplication(apolloClient, id)
//   if (!can) {
//     res.statusCode = 403;
//     res.end();
//   }
//   return;
// }

// ApplicationPage.guard = async (ctx, user) => {
//   const { id } = ctx.req ? ctx.req.query: ctx.query;
//   const authenticated = isUser(user);
//   if (!authenticated) {
//     return 401;
//   }

//   const isAuthorized = await canManageApplication(ctx.apolloClient, user, id);
//   if (isAuthorized) {
//     return 403;
//   }
// };

export default ApplicationPage;
